import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const RANGE = /(\d{1,2}):(\d{2})\s*([ap])\w*\s*[–-]\s*(\d{1,2}):(\d{2})\s*([ap])/gi;

const toMin = (h, m, ap) => ((+h % 12) + (ap.toLowerCase() === "p" ? 12 : 0)) * 60 + +m;
const fmt = (min) => { const h = Math.floor(min / 60); return `${h % 12 || 12}:${String(min % 60).padStart(2, "0")}${h >= 12 ? "p" : "a"}`; };

function ranges(value = "") {
  return [...value.matchAll(RANGE)].map((m) => [toMin(m[1], m[2], m[3]), toMin(m[4], m[5], m[6])]);
}

// Current day/minute in the clinic's timezone (Gardner, KS).
function clinicNow() {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: "America/Chicago", weekday: "long", hour: "numeric", minute: "numeric", hourCycle: "h23" }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  return { day: DAYS.indexOf(get("weekday")), min: +get("hour") * 60 + +get("minute") };
}

export function openStatus(hours, now = clinicNow()) {
  const byDay = Object.fromEntries((hours || []).map((h) => [h.day, ranges(h.value)]));
  const today = byDay[DAYS[now.day]] || [];
  const current = today.find(([s, e]) => now.min >= s && now.min < e);
  if (current) return { open: true, text: `Open now · until ${fmt(current[1])}` };
  const later = today.find(([s]) => s > now.min);
  if (later) return { open: false, text: `Opens at ${fmt(later[0])}` };
  for (let i = 1; i <= 7; i += 1) {
    const d = (now.day + i) % 7;
    const first = (byDay[DAYS[d]] || [])[0];
    if (first) return { open: false, text: `Opens ${i === 1 ? "tomorrow" : DAYS[d].slice(0, 3)} ${fmt(first[0])}` };
  }
  return null;
}

export function OpenNowBadge({ light = false }) {
  const { settings } = useSite();
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 60000);
    return () => clearInterval(t);
  }, []);
  const status = openStatus(settings?.hours);
  if (!status) return null;
  const tone = light ? "border-ivory/30 text-ivory" : "border-espresso/15 text-espresso";
  return (
    <Link to="/contact" data-testid="open-now-badge" title="Hours & location"
      className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-2 text-[0.68rem] uppercase tracking-[0.14em] whitespace-nowrap transition-colors duration-500 ${tone}`}>
      <span className={`h-2 w-2 rounded-full ${status.open ? "bg-emerald-500 animate-pulse" : "bg-brass"}`} />
      <span data-testid="open-now-badge-text">{status.text}</span>
    </Link>
  );
}
